import { isSignedIn, type Session, useSessionContext } from 'contexts/session'
import FigmaBox from 'mynt-components/components/FigmaBox'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { signInWithGoogle } from '../api'
import LoginForm, { type VPNStatus } from './LoginForm'

const buildSignInUrl = (redirectUri: string | null): string => {
  const url = new URL(window.location.origin + '/')
  if (redirectUri) {
    url.searchParams.append('redirect-uri', redirectUri)
  } else {
    url.pathname = '/start'
  }
  return url.toString()
}

const handleSignedInRedirect = (encodedRedirectUri: string | null, navigate: any) => {
  if (encodedRedirectUri) {
    const redirectUri: string = decodeURIComponent(encodedRedirectUri)
    window.location.href = redirectUri
  } else {
    navigate('/start')
  }
}

export const handleSignInWithGoogle = () => {
  const params = new URLSearchParams(window.location.search)
  const encodedRedirectUri: string | null = params.get('redirect-uri')
  const redirectUri: string | null = encodedRedirectUri ? decodeURIComponent(encodedRedirectUri) : null
  const signInUrl = buildSignInUrl(redirectUri)
  signInWithGoogle(signInUrl)
}

export const mapLoginTypeToVpnStatus = ({ isError, isLoading, role, errorMessage, timedOut }: Session): VPNStatus => {
  switch (true) {
    case timedOut:
    case isError:
      return 'disconnected'

    case isLoading:
      return 'connecting'

    case Boolean(errorMessage):
    case Boolean(role) && !isError:
      return 'connected'

    default:
      return 'connecting'
  }
}

const LoginFormContainer = () => {
  const navigate = useNavigate()
  const session = useSessionContext()
  const params = new URLSearchParams(window.location.search)
  const encodedRedirectUri: string | null = params.get('redirect-uri')

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore existing biome errors
  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore existing biome errors
  useEffect(() => {
    if (isSignedIn(session.role)) {
      handleSignedInRedirect(encodedRedirectUri, navigate)
    }
  }, [session.role])

  return (
    <FigmaBox fullWidth align="center">
      <LoginForm
        loading={session.isLoading}
        vpnStatus={mapLoginTypeToVpnStatus({
          errorMessage: session.errorMessage,
          isError: !!session.errorMessage,
          isLoading: session.isLoading,
          role: session.role,
          timedOut: session.timedOut,
        })}
        handleGoogleLogin={handleSignInWithGoogle}
        errorMessage={session.errorMessage}
      />
    </FigmaBox>
  )
}

export default LoginFormContainer
